import { create } from "zustand";

export interface SheetInstance {
	key: string;
	sheetContentType: string;
	props?: Record<string, any>;
	isPendingChange?: boolean;
}

interface SheetState {
	sheets: SheetInstance[];
	openSheet: (
		sheetContentType: string,
		props?: Record<string, any>
	) => void;
	closeSheet: (key: string) => void;
	closeTopSheet: () => void;
	closeAllSheets: () => void;
	updatePendingChange: (sheetKey: string, isPendingChange: boolean) => void;
}

let sheetKeyCounter = 0;

export const useSheetStore = create<SheetState>((set) => ({
	sheets: [],
	openSheet: (sheetContentType, props) =>
		set((state) => {
			const newKey = `sheet-${sheetKeyCounter++}`;
			return {
				sheets: [
					...state.sheets,
					{ key: newKey, sheetContentType, props },
				],
			};
		}),
	closeSheet: (key) =>
		set((state) => ({
			sheets: state.sheets.filter((sheet) => sheet.key !== key),
		})),
	closeTopSheet: () =>
		set((state) => ({
			sheets: state.sheets.slice(0, -1),
		})),
	closeAllSheets: () => set({ sheets: [] }),
	updatePendingChange: (sheetKey: string, isPendingChange: boolean) =>
		set((state) => ({
			sheets: state.sheets.map((sheet) =>
				sheet.key === sheetKey ? { ...sheet, isPendingChange } : sheet
			),
		})),
}));
